// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"121":"gallery","548":"calendar"}[chunkId] + "." + {"121":"b5b43c82","548":"d7ddcca5"}[chunkId] + ".css";
};